import { GridRow } from '../GeneralContractsFunctional'
import { NavLink } from 'react-router-dom'
import { useCallback } from 'react'
import { ContractState } from '@ail/contracts-api'
import { useTranslation } from 'react-i18next'

interface Props {
  row: GridRow
}

interface IconProps {
  color: string
  title: string
  icon: string
  url: string
  size?: string
}

export default function ReplacementStateCell({ row }: Props) {
  const { t } = useTranslation('common')

  const getIcon = useCallback(({ color, title, icon, url, size }: IconProps) => {
    return (
      <div className="replacementStateIcon">
        <NavLink style={{ color, fontSize: size ? size : '20px' }} title={title} className={icon} to={url} />
      </div>
    )
  }, [])

  const { futureContract, replacementOrderCondition } = row
  if (replacementOrderCondition?.missingReplacementOrder && !futureContract) {
    return getIcon({
      color: 'red',
      title: t('MISSING_REPLACEMENT_ORDER'),
      icon: 'icon-change-generic',
      url: `/generalContracts/details/${row.contract.id}`,
    })
  }

  if (replacementOrderCondition?.processingOrder && !futureContract) {
    return getIcon({
      color: '#707070',
      title: `${t('STATUS_PENDING')} / ${t('PROCESSING')}`,
      icon: 'icon-pending',
      url: '#',
      size: '18px',
    })
  }

  if (replacementOrderCondition?.returnWithoutReplacement && !futureContract) {
    return getIcon({
      color: '#39B54A',
      title: t('RETURN_WITHOUT_REPLACEMENT'),
      icon: 'icon-delivery',
      url: `/generalContracts/details/${row.contract.id}`,
    })
  }
  return futureContract?.id
    ? getIcon({
        color: '#39B54A',
        title: row.replacedContract?.reference || futureContract?.reference || '',
        icon: 'icon-change-car',
        url: `/${
          futureContract && futureContract?.state === (ContractState.Initialized || ContractState.Running)
            ? 'orderAndDelivery'
            : 'generalContracts'
        }/details/${futureContract?.id}`,
      })
    : undefined
}
